module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3885095922/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main